/**
 * Send lead data to Google Sheets
 * @param {Object} data - Lead data to send
 * @param {string} data.name - Contact name
 * @param {string} data.email - Contact email
 * @param {string} data.phone - Contact phone number
 * @param {string} data.countryCode - Country code (optional)
 * @param {string} data.source - Form source
 * @param {string} data.type - Lead type (contact/download)
 * @return {Promise<Object>} Response from Google Sheets
 */
export const sendToGoogleSheets = async (data) => {
  try {
    // Google Apps Script Web App URL - REPLACE THIS WITH YOUR DEPLOYED SCRIPT URL
    const GOOGLE_SCRIPT_URL = process.env.NEXT_PUBLIC_GOOGLE_SHEETS_URL || "YOUR_GOOGLE_APPS_SCRIPT_URL_HERE";

    if (GOOGLE_SCRIPT_URL === "YOUR_GOOGLE_APPS_SCRIPT_URL_HERE") {
      console.warn("Google Sheets URL not configured. Skipping Google Sheets integration.");
      return { status: "skipped", message: "Google Sheets URL not configured" };
    }

    // Prepare the data to send
    const payload = {
      timestamp: new Date().toISOString(),
      name: data.name || "",
      email: data.email || "",
      countryCode: data.countryCode || "",
      phone: data.phone || "",
      source: data.source || "Unknown",
      type: data.type || "contact",
    };

    console.log("Sending to Google Sheets:", payload);

    // Send data to Google Apps Script
    await fetch(GOOGLE_SCRIPT_URL, {
      method: "POST",
      mode: "no-cors", // Google Apps Script requires no-cors mode
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    // Note: With no-cors mode, we won't get a readable response
    // The request will still work, but we can't read the response
    console.log("Data sent to Google Sheets successfully");

    return {
      status: "success",
      message: "Data sent to Google Sheets",
    };
  } catch (error) {
    console.error("Error sending to Google Sheets:", error);
    return {
      status: "error",
      message: error.message,
      error: error,
    };
  }
};

export default sendToGoogleSheets;
